import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyTelegramTheme, initTelegram } from './telegram/telegram';
import './styles.css';

initTelegram();
applyTelegramTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
